
















import Vue from "vue";

const Footer = Vue.extend({
  name: "Footer",
  data: () => ({
    year: window.moment().format("YYYY"),
  }),
});
export default Footer;
